export const YEARS_OPTIONS = [
  { value: 2015, name: '2015', disabled: false },
  { value: 2030, name: '2030', disabled: false },
  { value: 2040, name: '2040', disabled: false },
];
